import FreemiumEventCreateAlbumsStep from './FreemiumEventCreateAlbumsStep';

export default FreemiumEventCreateAlbumsStep;
